import React from 'react';
import { Box } from '@mui/material';
import AppHeader from 'components/Layouts/Header';
import AppSidebar from 'components/Layouts/Sidebar';
import { Outlet } from 'react-router-dom';
import style from './style.module.scss';

const AppLayout: React.FC = (): React.ReactElement => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <AppHeader />

      <Box className={style.layout} sx={{ display: 'flex', flex: 1 }}>
        <AppSidebar />
        <Box component="main" sx={{ flex: 1, overflowY: 'auto' }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default AppLayout;
